import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@material-ui/core";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

import useStyles from "./styles";

export default function EnhancedTableHead({
  withCheckbox,
  numSelected,
  rowCount,
  columns,
  onSelectAllClick,
  withBreakDown,
}) {
  const { header } = useStyles();
  return (
    <TableHead className={header}>
      <TableRow>
        {withCheckbox && (
          <TableCell padding="checkbox">
            <Checkbox
              style={{ color: "white" }}
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
        )}

        {columns.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || "inherit"}
            padding={headCell.padding || "default"}
          >
            {headCell.label}
          </TableCell>
        ))}

        {withBreakDown && <TableCell className="breakdownCol" />}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  withCheckbox: PropTypes.bool,
  numSelected: PropTypes.number,
  rowCount: PropTypes.number,
  columns: PropTypes.array,
  onSelectAllClick: PropTypes.func,
  withBreakDown: PropTypes.bool,
};

EnhancedTableHead.defaultProps = {
  withCheckbox: false,
  numSelected: 0,
  rowCount: 0,
  columns: [],
  onSelectAllClick: () => {},
  withBreakDown: false.valueOf,
};
